import styled from 'styled-components';

export const RouteListStyle = styled.div`
  .rule-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }
  .rule-title {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .rule-order {
    color: #7f8a9a;
    font-size: 12px;
    margin-right: 8px;
  }
  .rule-condition {
    color: #626e7f;
    font-size: 12px;
  }
  .rule-target {
    color: var(--settings-accent);
    font-weight: 600;
    margin-top: 9px;
  }
  .rule-actions {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
  }
  .rule-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #626e7f;
  }
  .rule-editor {
    padding: 24px;
    background: #fbfcfe;
    border-bottom: 1px solid #e4e8ef;
  }
  .rule-editor-actions {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }
  .rule-default {
    padding: 20px 24px;
    color: #626e7f;
    font-size: 12px;
    border-top: 1px solid #edf0f4;
  }
  .rule-default dl {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    margin: 10px 0 0;
  }
  .rule-default dd {
    margin: 0;
    color: #283141;
  }
  .rule-account {
    padding: 10px 0;
    font-size: 12px;
    color: #626e7f;
    overflow-wrap: anywhere;
  }
  @media (max-width: 600px) {
    .rule-summary {
      flex-wrap: wrap;
    }
  }
`;
